

const KurtiProduct = ({product}) => {
    
    const productSizes = (product) => {
        const sizes = product.variants.map(variant => variant.size!== '' && ({
          size: variant.size,
          out_of_stock: variant.out_of_stock ? 'Out of Stock' : "In Stock",
          sku: variant.sku,
          price: variant.price,
          actual_price: variant.actual_price
        }));  
        return sizes
      }
      console.log("eeeeeeeeeee",product)
    return (
        <>
            <td className='title'>
                {product.name}
                <span>{product['subcategory']['name'] === "Sarees" && "SKU: " + product.variants[0].sku}</span>
                <span>{product['subcategory']['name'] + ' > '}  {product['subcategory']['name']}</span>
            </td>
            <td> <h5 className="price">₹{Math.round(product.variants[0].price)} <span className='strikedPrice'>₹{Math.round(product.variants[0].actual_price)}</span></h5> </td>
            <td>
            <div className="product-size m-b-10">
            {product.subcategory.name === "Sarees" && <span className={ ( product.variants[0].out_of_stock ? ' bg-danger ' : ' bg-success ') + " badge  m-0"}>{product.variants[0].out_of_stock ?   'Out of Stock' : 'In Stock'}</span>}
                {productSizes(product).map((size, index) =>  
                <>
                {  <div> {size.size} - {size.sku} - <span className={ ( size.out_of_stock === "Out of Stock" ? ' text-danger ' : 'text-success ') + "   m-0"}>{size.out_of_stock}</span></div> }
                </>
                )}
                </div>
            </td>
            <td>
                <table className="table table-hover mb-3">
                    <thead>
                        <tr>
                        <th>SKU</th>
                        <th>Price</th>
                        <th></th>
                        <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {product?.variants?.map((variant,index) => 
                        <tr key={index}> 
                            
                            <td className='title'>  {variant.sku}   </td>
                            <td> <h5 className="price">₹{Math.round(variant.price)} <span className='strikedPrice'>₹{Math.round(variant.actual_price)}</span></h5> </td>

                            <td>  
                                <div className="btn-group product-size m-b-10">
                                {variant.out_of_stock && <div className='btn disable-btn'>{variant.size}</div>}
                                </div>
                            
                            </td>
                                
                            <td>
                            <span className={ ( variant.out_of_stock ? ' bg-danger ' : ' bg-success ') + " badge  m-0"}>{variant.out_of_stock ?   'Out of Stock' : 'In Stock'}</span>
                            </td>
                        </tr>
                        )}
                    
                    </tbody>
                </table>
            </td>
            <td></td>
                               
        </>
    )
}


export default KurtiProduct;